import { searchAndRemoveByKeyVal } from "@utils/array-helpers";
import type { FileLocation, FileItem } from "../interfaces";

export const showHideFiles = (
  fileLocations: FileLocation[] | undefined,
  targetFolder: string,
  showFiles: boolean,
): FileLocation[] => {
  return fileLocations
    ? fileLocations.map((location) => {
        return {
          ...location,
          showFiles:
            location.location_name === targetFolder
              ? showFiles
              : location.showFiles,
          folders:
            location.location_name !== targetFolder
              ? showHideFiles(location.folders, targetFolder, showFiles)
              : location.folders,
        };
      })
    : [];
};

export const updateFileLocations = (
  fileLocations: FileLocation[] | undefined,
  actionType: string,
  file_path: string,
  folder_path: string,
  location_name: string,
  parent_location: string,
): FileLocation[] => {
  return fileLocations
    ? fileLocations.map((location) => {
        return {
          ...location,
          files:
            actionType === "updateFile" &&
            location.location_name === folder_path
              ? searchAndRemoveByKeyVal("file_path", file_path, location.files)
              : location.files,
          folders:
            actionType === "updateFolder" &&
            location.location_name === parent_location
              ? searchAndRemoveByKeyVal(
                  "location_name",
                  location_name,
                  location.folders,
                )
              : updateFileLocations(
                  location.folders,
                  actionType,
                  file_path,
                  folder_path,
                  location_name,
                  parent_location,
                ),
        };
      })
    : [];
};

export const flattenArray = (
  array: any[],
  key: "folders" | "files",
  newSearchValue?: boolean,
): any[] => {
  let result: any[] = [];
  if (key === "folders") {
    array.forEach((a) => {
      result.push({ ...a, showFiles: false, searchResults: true });
      if (Array.isArray(a["folders"])) {
        result = result.concat(
          flattenArray(a["folders"], "folders", newSearchValue),
        );
      }
    });
  } else {
    array.forEach((a) => {
      result.push(...a["files"]);
      if (Array.isArray(a["folders"])) {
        result = result.concat(
          flattenArray(a["folders"], "files", newSearchValue),
        );
      }
    });
  }
  return result;
};

export function checkFolderRestrictedChars(inputValue: string): boolean {
  return inputValue.match(/[!@#$%^&*()+=\[\]{}:;'"<>,./|\\`~]/) !== null;
}

export function checkFileRestrictedChars(inputValue: string): boolean {
  return inputValue.match(/[\[\]{^}%`>~<#|\\]/) !== null;
}
